module.exports = __webpack_public_path__ + "img/pr-9.31e3023b.png";